<template>
  <tm-feature-tooltip
    max-width="281px"
    :is-open="isOpen"
    :position="position"
    :arrow-vertical-position="arrowVerticalPosition"
    :target="target"
    :z-index="5999"
  >
    <div class="compose-toggle-tooltip">
      <tm-modal-close-btn
        class="close-btn"
        icon-size="medium"
        button-size="small"
        @close="onClose"
      />
      <div class="d-flex align-center">
        <tm-icon
          name="tmi-swap-horiz"
          class="mr-2"
          color="blue"
          size="xxxLarge"
        />
        <div class="mr-2 body-text-semi-bold-14 lh-26">{{ $t('composeToggleTooltip.title') }}</div>
      </div>

      <div class="compose-toggle-tooltip__text body-text-regular-13 lh-18">
        {{ $t('composeToggleTooltip.text') }}
      </div>
    </div>
  </tm-feature-tooltip>
</template>

<script setup lang="ts">
import { ref } from '@/composition/vue/compositionApi'
import TmFeatureTooltip from '@/components/shared/TmFeatureTooltip.vue'
import TmModalCloseBtn from '@/components/shared/modals/tmModal/TmModalCloseBtn.vue'
import TmIcon from '@/components/shared/TmIcon.vue'
import { getUiSettingsService } from '@/core/container/ioc'

defineProps<{
  position?: 'left' | 'right'
  arrowVerticalPosition?: 'top' | 'middle' | 'bottom'
  target?: HTMLElement
}>()

const isOpen = ref(true)

const onClose = () => {
  isOpen.value = false
  getUiSettingsService().updateSettings({ composeSwitchChannelsTooltipHidden: true })
}
</script>
<style lang="scss" scoped>
.close-btn {
  position: absolute;
  top: 4px;
  right: 4px;
}
.compose-toggle-tooltip {
  padding: 12px 20px;

  &__text {
    margin-top: 6px;
  }
}
</style>
